// Author: Walid Birouk
$(function(){
    $('#showBtn').click(function(){
        $('#myModal').modal('show');
    });
    $('#closeModal').click(function(){
        $('#myModal').modal('hide');
    });
});
$(function(){
    $('#showBtn1').click(function(){
        $('#myModal1').modal('show');
    });
    $('#closeModal1').click(function(){
        $('#myModal1').modal('hide');
    });
});
$(function(){
    $('#showBtn2').click(function(){
        $('#myModal2').modal('show');
    });
    $('#closeModal2').click(function(){
        $('#myModal2').modal('hide');
    });
});
$(function(){
    $('#showBtn3').click(function(){
        $('#myModal3').modal('show');
    });
    $('#closeModal3').click(function(){
        $('#myModal3').modal('hide');
    });
});
$(function(){
    $('#showBtn4').click(function(){
        $('#myModal4').modal('show');
    });
    $('#closeModal4').click(function(){
        $('#myModal4').modal('hide');
    });
});
$(function(){
    $('#showBtn5').click(function(){
        $('#myModal5').modal('show');
    });
    $('#closeModal5').click(function(){
        $('#myModal5').modal('hide');
    });
});
$(function(){
    $('#showBtn6').click(function(){
        $('#myModal6').modal('show');
    });
    $('#closeModal6').click(function(){
        $('#myModal6').modal('hide');
    });
});
$(function(){
    $('#showBtn7').click(function(){
        $('#myModal7').modal('show');
    });
    $('#closeModal7').click(function(){
        $('#myModal7').modal('hide');
    });
});
$(function(){
    $('#showBtn8').click(function(){
        $('#myModal8').modal('show');
    });
    $('#closeModal8').click(function(){
        $('#myModal8').modal('hide');
    });
});
$(function(){
    $('#showBtn9').click(function(){
        $('#myModal9').modal('show');
    });
    $('#closeModal9').click(function(){
        $('#myModal9').modal('hide');
    });
});


// needed for the mobile version

$('.mob-nav').click(() => {
    $('.mob-links').addClass('open');
});

$(document).click(() => {
    if ($(window).width() < 992) {
        if (!$(event.target).closest('.mob-links,.mob-nav').length) {
            event.preventDefault();
            $('.mob-links').removeClass('open');
        }
    }
});
